<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-4">Environments</h1>

@if (isLoading()) {
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
}
@else {

  @if (error()) {
    <app-error-message
      [error]="error()"
      [heading]="'Could not load environments'"
      [showRetry]="true"
      (retry)="reload()"
    ></app-error-message>
  }
  @else {
    @if (environments()?.length == 0) {
      <p>No environments are currently available.</p>
    }
    @else {
      <div class="tw-flex tw-flex-wrap tw-gap-4">
  
        @for (env of environments(); track env.environmentId) {
          <app-environment
            class="tw-w-full tw-h-64 lg:tw-w-[100%] xl:tw-w-[48%] 2xl:tw-w-[48%] md:tw-h-52"
            [environment]="env"
          >
          </app-environment>
        }
      </div>
    } 
  }

}